import { useState, useEffect, useCallback } from "react";
import { Box, Button, Dialog, DialogActions, DialogTitle, Slide, Stack, Tooltip } from "@mui/material";
import Header from "../../components/Header";
import DebFormModal from "../../components/DebFormModal";
import {
    DebFormSelect,
    DebFormTextInput,
} from "../../components/DebFormComponents";
import DataTable from "../../components/DataTable";
import AddBoxIcon from "@mui/icons-material/AddBox";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useSnackbar } from "notistack";
import { company as companyService } from "../../services/companies";
import { surveyTemplates as templateService } from "../../services/surveyTemplates";
import {surveyTemplateValidationSchema} from "../../schemas/survey-templates.js";


//TRANSICIÓN DEL ALERT DE ELIMINACIÓN
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


const newTemplateValues = {
    companyId: "",
    channelType: "WHATSAPP",
    name: "",
    template: "",
    defaultTemplate: false,
    finalMessage: "",
    messageNoAnswer: ""
};

const SurveyTemplates = () => {
    // MODAL DE EDICIÓN / CREACIÓN
    const [modalState, setModalState] = useState(false);
    const [modalInitialValues, setModalInitialValues] = useState(newTemplateValues);

    const [companies, setCompanies] = useState([]);
    const getCompanies = async () => {
        let companies = await companyService.getAll();
        setCompanies(companies);
        return companies;
    };

    const [surveyTemplates, setSurveyTemplates] = useState([]);
    const getSurveyTemplates = async (companiesParam) => {
        let companyList = companiesParam;
        if(!companyList){
            companyList = companies;
        }
        try {
            const res = await templateService.getWhatsappTemplates();
            const templates = res.content;

            templates.forEach(template => {
                const company = companyList.find(company => company.id === template.companyId);
                if (company) {
                    template.companyName = company.name;
                }
            });
            setSurveyTemplates(templates);
        } catch (err) {
            console.error(err);
            enqueueSnackbar("Error buscando templates", {
                preventDuplicate: true,
                variant: "error",
            });
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                let companyList = await getCompanies();
                await getSurveyTemplates(companyList);
            } catch (err) {
                enqueueSnackbar("Error buscando templates o compañias", {
                    preventDuplicate: true,
                    variant: "error",
                });
            }
        };

        fetchData();
    }, []);

    const { enqueueSnackbar } = useSnackbar();

    const handleSubmit = async (values) => {
        try {
            if (values.id) {
                //estamos editando
                const res = await templateService.update(values);
                enqueueSnackbar("Template editado", {
                    preventDuplicate: true,
                    variant: "success",
                });
            } else {
                const res = await templateService.create(values);
                enqueueSnackbar("Template creado", {
                    preventDuplicate: true,
                    variant: "success",
                });
            }
            closeModal();
            await getSurveyTemplates(companies);
        } catch (error) {
            if (values.id) {
                enqueueSnackbar("Ocurrió un error al editar el template", {
                    preventDuplicate: true,
                    variant: "error",
                });
            } else {
                enqueueSnackbar("Ocurrió un error al crear el template.", {
                    preventDuplicate: true,
                    variant: "error",
                });
                error.response.status === 500 &&
                enqueueSnackbar("Verifique que no exista ya un template con los datos ingresados", {
                    preventDuplicate: true,
                    variant: "error",
                });
            }
            enqueueSnackbar("Verifique la existencia de un template con esa Key en Whatsapp", {
                preventDuplicate: true,
                variant: "warning",
            });
        }
    };

    const openModal = () => {
        setModalState(true);
    };

    const closeModal = () => {
        setModalState(false);
        setModalInitialValues(newTemplateValues);
    };

    const handleEdit = (template) => {
        setModalInitialValues(template);
        openModal();
    };

    const handleCreateTemplate = () => {
        setModalInitialValues(newTemplateValues);
        openModal();
    };

    // ALERT DE ELIMINACIÓN
    const [selectedDelete, setSelectedDelete] = useState();
    const [openAlert, setOpenAlert] = useState(false);
    const handleAlertClose = () => {
        setOpenAlert(false);
    };
    const handleAlertOpen = (selectedTemplate) => {
        setSelectedDelete(selectedTemplate);
        setOpenAlert(true);
    };

    const handleDelete = async () => {
        try {
            await templateService.delete(selectedDelete.id);
            enqueueSnackbar("Se eliminó el template " + selectedDelete.name, {
                preventDuplicate: true,
                variant: "success",
            });
            handleAlertClose();
            await getSurveyTemplates();
        } catch (error) {
            enqueueSnackbar("Ocurrió un error eliminando el template", {
                preventDuplicate: true,
                variant: "error",
            });
        }
    };

    return (
        <Box>
            <Header title="TEMPLATES" subtitle="Lista de Templates de Whatsapp" />
            <DataTable
                loading={!surveyTemplates.length}
                rows={surveyTemplates}
                columns={[
                    { field: "id", headerName: "ID", flex: 0.2 },
                    {
                        field: "companyName",
                        headerName: "Compañía",
                        flex: 0.8,
                        renderCell: (params) => params?.row?.companyName ?? ""
                    },
                    {
                        field: "name",
                        headerName: "Nombre",
                        flex: 1,
                        renderCell: (params) => params.row.name

                    },
                    {
                        field: "whatsappKey",
                        headerName: "Whatsapp key",
                        flex: 1,
                        renderCell: (params) => params.row.whatsappKey

                    },
                    {
                        field: "channelType",
                        headerName: "Canal",
                        flex: 0.5,
                        renderCell: (params) => params?.row.channelType
                    },
                    {
                        field: "finalMessage",
                        headerName: "Mensaje final",
                        flex: 1,
                        renderCell: (params) => params?.row.finalMessage
                    },
                    {
                        field: "messageNoAnswer",
                        headerName: "Mensaje no respondida",
                        flex: 1,
                        renderCell: (params) => params?.row.messageNoAnswer
                    }
                ]}
                rowActions={[
                    {
                        label: "Editar",
                        icon: <EditIcon />,
                        action: handleEdit,
                    },
                    {
                        label: "Eliminar",
                        icon: <DeleteIcon />,
                        action: handleAlertOpen,
                        showInMenu: true,
                    },
                ]}
                headerActions={[
                    {
                        label: "Crear Template",
                        icon: <AddBoxIcon />,
                        action: handleCreateTemplate,
                    },
                ]}
            />

            {/* MODAL DE CREACIÓN / EDICIÓN DE TEMPLATE */}
            <DebFormModal
                maxWidth="sm"
                fullWidth={true}
                open={modalState}
                onClose={closeModal}
                onReject={closeModal}
                initialValues={modalInitialValues}
                onSubmit={handleSubmit}
                formikProps={{
                    enableReinitialize: true,
                    validationSchema: surveyTemplateValidationSchema,
                }}
                headerText={
                    modalInitialValues?.id
                        ? "Editar Template"
                        : "Crear Template"
                }>
                <Stack spacing={1}>
                    <DebFormSelect
                        label={"Compañía"}
                        name={"companyId"}
                        selectOptions={Array.from(companies)?.map((company) => {
                            return {
                                label: company.name,
                                value: company.id
                            };
                        })}
                    />
                    <DebFormSelect
                        label={"Canal"}
                        name={"channelType"}
                        selectOptions={[
                            { label: "Whatsapp", value: "WHATSAPP" },
                            { label: "Whatsapp Link", value: "WHATSAPP_LINK" },
                        ]}
                    />
                    <DebFormTextInput label={"Whatsapp key"} name={"whatsappKey"} />
                    <DebFormTextInput label={"Label"} name={"name"} />
                    <DebFormTextInput label={"Mensaje final"} name={"finalMessage"} />
                    <DebFormTextInput label={"Mensaje no respondida"} name={"messageNoAnswer"} />
                </Stack>
            </DebFormModal>
            {/* ALERT DE ELIMINACIÓN */}
            <Dialog
                open={openAlert}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleAlertClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle sx={{m:"2rem 3rem 1rem 3rem", gap:"1rem", p:"0"}} >{"¿Esta seguro que desea eliminar?"}</DialogTitle>
                <DialogActions>
                    <Button onClick={handleAlertClose} variant="outlined" color="error">Cancelar</Button>
                    <Button onClick={handleDelete} variant="contained" color="success">Confirmar</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default SurveyTemplates;
